import React from 'react';
import BrowseTiles from '../BrowseTiles/BrowseTiles';
import PageNotFoundHeader from '../PageNotFoundHeader/PageNotFoundHeader';

const PageNotFound = () => (
  <BrowseTiles>
    <PageNotFoundHeader />
  </BrowseTiles>
);

export default PageNotFound;
